import { useState } from 'react';
import { LogoutModal } from '../LogoutModal/LogoutModal';
import { IconButton } from '@/shared/ui/IconButton/IconButton';
import Exit from '@/shared/assets/icons/exit.svg';
import { useScreenDetector } from '@/shared/lib/hooks/useScreenDetector';

export const LogoutButton = () => {
  const [open, setOpen] = useState(false);

  const { isMobile } = useScreenDetector();
  return (
    <>
      <IconButton size={isMobile ? 'm' : 'l'} color={'red'} onClick={() => setOpen(true)}>
        <Exit />
      </IconButton>

      {open && <LogoutModal open={open} onClose={() => setOpen(false)} />}
    </>
  );
};
